import { client } from './client';
import { endpoints } from './endpoints';

export type FetchAuthTokenRequest = {
  userName: string;
  password: string;
};

export type FetchAuthTokenResponse = {
  accessToken: string;
  refreshToken: string;
};

export async function fetchAuthToken(
  data: FetchAuthTokenRequest,
): Promise<FetchAuthTokenResponse> {
  const response = await client.post(endpoints.AUTH_URL, data);

  return response.data;
}
